import { ValidationField, Validator, dateFormat, email, format, isDateBeforeStart, maxLength, presence, regExpInvalidCharPattern } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
export class ShomeiEntryValidator extends Validator {
    constructor(data) {
        const constraints = {
            soufuName: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(30)
            },
            postcode: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: new RegExp("^[0-9]{3}-?[0-9]{4}$"), message: commonStore.messages.PV0014 })
            },
            adr1: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            adr2: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            adr3: {
                format: regExpInvalidCharPattern,
                length: maxLength(35)
            },
            tel: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: new RegExp("^(060|070|080|090)-?\\d{4}-?\\d{4}$"), message: commonStore.messages.PV0012 })
            },
            email: {
                presence: presence(false, commonStore.messages.PV0001),
                length: maxLength(256),
                email: email({ message: commonStore.messages.PV0013 })
            },
            selectedShomeiKbn: {
                presence: presence(false, commonStore.messages.PV0002)
            },
            shakoChushamei: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(30)
            },
            shakoKukaku: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(10)
            },
            shinseishaName: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(30)
            },
            shinseishaPostcode: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: new RegExp("^[0-9]{3}-?[0-9]{4}$"), message: commonStore.messages.PV0014 })
            },
            shinseishaAdr1: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            shinseishaAdr2: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            shinseishaAdr3: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            shinseishaTel: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: new RegExp("^(060|070|080|090)-?\\d{4}-?\\d{4}$"), message: commonStore.messages.PV0012 })
            },
            rentStartDate: {
                presence: presence(false, commonStore.messages.PV0001),
                dateFormat: dateFormat(commonStore.messages.PV0005)
            },
            rentEndDate: {
                presence: presence(false, commonStore.messages.PV0001),
                dateFormat: dateFormat(commonStore.messages.PV0005),
                isDateBeforeStart: isDateBeforeStart(commonStore.messages.PV0026, "rentStartDate")
            },
            file: {
                presence: presence(false, commonStore.messages.PV0028)
            }
        };
        super(data.model, constraints);
        this.soufuName = new ValidationField("soufuName", this.data, constraints);
        this.postcode = new ValidationField("postcode", this.data, constraints);
        this.adr1 = new ValidationField("adr1", this.data, constraints);
        this.adr2 = new ValidationField("adr2", this.data, constraints);
        this.adr3 = new ValidationField("adr3", this.data, constraints);
        this.tel = new ValidationField("tel", this.data, constraints);
        this.email = new ValidationField("email", this.data, constraints);
        this.selectedShomeiKbn = new ValidationField("selectedShomeiKbn", this.data, constraints);
        this.shakoChushamei = new ValidationField("shakoChushamei", this.data, constraints);
        this.shakoKukaku = new ValidationField("shakoKukaku", this.data, constraints);
        this.shinseishaName = new ValidationField("shinseishaName", this.data, constraints);
        this.shinseishaPostcode = new ValidationField("shinseishaPostcode", this.data, constraints);
        this.shinseishaAdr1 = new ValidationField("shinseishaAdr1", this.data, constraints);
        this.shinseishaAdr2 = new ValidationField("shinseishaAdr2", this.data, constraints);
        this.shinseishaAdr3 = new ValidationField("shinseishaAdr3", this.data, constraints);
        this.shinseishaTel = new ValidationField("shinseishaTel", this.data, constraints);
        this.rentStartDate = new ValidationField("rentStartDate", this.data, constraints);
        this.rentEndDate = new ValidationField("rentEndDate", this.data, constraints);
        this.file = new ValidationField("file", this.data, constraints);
    }
    soufuName;
    postcode;
    adr1;
    adr2;
    adr3;
    tel;
    email;
    selectedShomeiKbn;
    shakoChushamei;
    shakoKukaku;
    shinseishaName;
    shinseishaPostcode;
    shinseishaAdr1;
    shinseishaAdr2;
    shinseishaAdr3;
    shinseishaTel;
    rentStartDate;
    rentEndDate;
    file;
}
